var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 15L15.19 12L10 8.99999V15ZM21.56 7.16999C21.69 7.63999 21.78 8.26999 21.84 9.06999C21.91 9.86999 21.94 10.56 21.94 11.16L22 12C22 14.19 21.84 15.8 21.56 16.83C21.31 17.73 20.73 18.31 19.83 18.56C19.36 18.69 18.5 18.78 17.18 18.84C15.88 18.91 14.69 18.94 13.59 18.94L12 19C7.81002 19 5.20002 18.84 4.17002 18.56C3.27002 18.31 2.69002 17.73 2.44002 16.83C2.31002 16.36 2.22002 15.73 2.16002 14.93C2.09002 14.13 2.06002 13.44 2.06002 12.84L2.00002 12C2.00002 9.80999 2.16002 8.19999 2.44002 7.16999C2.69002 6.26999 3.27002 5.68999 4.17002 5.43999C4.64002 5.30999 5.50002 5.21999 6.82002 5.15999C8.12002 5.08999 9.31002 5.05999 10.41 5.05999L12 4.99999C16.19 4.99999 18.8 5.15999 19.83 5.43999C20.73 5.68999 21.31 6.26999 21.56 7.16999Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon-youtube.7e54bfd5e170a44b6f2ae2538396fb51.svg";
export { ForwardRef as ReactComponent };